import { client } from "../../sanity/client";

import { groq } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import ConditionUtilisation from "page/ConditionUtilisation";

const query = groq`*[_type == "post" && slug.current == $slug][0]{
    title,
    "name": author->name,
    "categories": categories[]->title,
    "authorImage": author->image,
    body,
    "content": [
        {
            ...SanityHeadSeo->{
                ...
            },
        },
        {
            ...SanityFooter->{
                ...
            },
        }
    ],
  }`;

export const getStaticProps = async () => {
  const slug = "conditions-d-utilisation";
  const post = await client.fetch(query, { slug });
  if (post) {
    return {
      props: {
        post,
      },
    };
  } else {
    return {
      props: {},
    };
  }
};

export default function Page(props) {
  const { t, lang } = useTranslation("common");

  const post: any = props;
  //
  if (post) {
    return <ConditionUtilisation post={post} />;
  } else {
    return null;
  }
}
